import { Input } from "components/atoms";
import { IMerchImageResponse } from "services/merch/types";
import { Button, Container } from "components/atoms";
import { BUTTON_VARIANT } from "types/components/button/button.interface";
import { PiTrash, PiCheckSquareOffset, PiStar } from "react-icons/pi";
import "./MerchImageCard.scss";
import classNames from "classnames";
import { t } from "i18next";

interface IMerchImageCard {
  imageId: string;
  imageLink: string;
  imagePreviewLink: string;
  displayMode: boolean;
  onDeleteImage: (imageId: string) => void;
  onMainImageIdChange: () => void;
  currentImage?: string;
  showMainImageControls: boolean;
  isMain?: boolean;
}

const MerchImageCard = ({
  imageId,
  imageLink,
  imagePreviewLink,
  displayMode,
  onDeleteImage,
  onMainImageIdChange,
  currentImage,
  showMainImageControls,
  isMain,
}: IMerchImageCard) => {
  const isCurrent = currentImage === imageId;

  return (
    <div className="merch-image-card">
      {!displayMode && !isMain && showMainImageControls  && (
        <Button
          variant={BUTTON_VARIANT.submit}
          onlyIcon
          onClick={onMainImageIdChange}
        >
          <Button.Icon icon={<PiCheckSquareOffset />} />
        </Button>
      )}
      {!displayMode ? (
        <div className="merch-image-card-remove-wrapper">
          <Button
            variant={BUTTON_VARIANT.remove}
            onlyIcon
            onClick={() => onDeleteImage(imageId)}
          >
            <Button.Icon icon={<PiTrash />} />
          </Button>
        </div>
      ) : (
        <div></div>
      )}
      <div
        className={classNames("image-input-wrapper", {
          "highlight-border": showMainImageControls && isCurrent,
        })}
      >
        <Input.Image
          key={imageId}
          editable={false}
          fullResolutionUrl={imageLink}
        />
      </div>
    </div>
  );
};

export default MerchImageCard;
